import { Component, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { AppService } from "../services/app.service";
import { environment } from "../../environments/environment";
import { ImageCroppedEvent, ImageCropperComponent } from "ngx-image-cropper";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";
import { NgxSpinnerService } from "ngx-spinner";
import { FileSystemFileEntry } from "ngx-file-drop";
import * as AWS from "aws-sdk/global";
import * as S3 from "aws-sdk/clients/s3";
import { SupportService } from "../services/support-service";
import { Lightbox } from "ngx-lightbox";
import { Router } from "@angular/router";

@Component({
  selector: "app-profile-photos",
  templateUrl: "./profile-photos.component.html",
  styleUrls: ["./profile-photos.component.scss"],
})
export class ProfilePhotosComponent implements OnInit {
  //decalare variables
  imagesList: any;
  @ViewChild("cropimage") cropimage: TemplateRef<any>;
  @ViewChild(ImageCropperComponent) imageCropper: ImageCropperComponent;
  config = {
    ignoreBackdropClick: true,
  };
  filesList: any;
  croppedImage: any;
  awsUploadfiles: any;
  modalRef: BsModalRef;
  awsUploadData: any;
  imageChangedEvent: any;
  couldFrontURL = environment.cloudFrontURL;

  constructor(
    private appservice: AppService,
    private modalService: BsModalService,
    private spinner: NgxSpinnerService,
    private supportService: SupportService,
    private lightbox: Lightbox,
    private router: Router
  ) {
    //initalize variable
    this.imagesList = [];
    this.croppedImage = "";
    this.imageChangedEvent = "";
  }

  ngOnInit() {
    this.getLanguage();
    this.getallsavedimagelist();
    if (localStorage.getItem("testCenterName") !== null) {
      this.supportService.testCenterName.next(
        localStorage.getItem("testCenterName")
      );
    }

    if (localStorage.getItem("stateName") !== null) {
      this.supportService.stateName.next(localStorage.getItem("stateName"));
    }
  }

  savedImageList: any = [];
  getallsavedimagelist() {
    if (localStorage.getItem("testCenterId")) {
      this.appservice
        .getalluploadedpicsbytc(localStorage.getItem("testCenterId"))
        .subscribe(
          (res) => {
            if (res && res["entity"]) {
              this.savedImageList = [];
              for (let i = 0; i < res["entity"].length; i++) {
                const src = environment.cloudFrontURL + res["entity"][i].image;
                const caption = "Profile photo" + (i + 1);
                const thumb =
                  environment.cloudFrontURL + res["entity"][i].image;
                const album = {
                  src: src,
                  caption: caption,
                  thumb: thumb,
                  id: res["entity"][i].id,
                  backenddata: true,
                  key: null,
                };
                this.savedImageList.push(album);
              }
            }
          },
          (err) => {
            this.appservice.sessionOut(err);
          }
        );
    }
  }

  openImage(index) {
    this.lightbox.open(this.savedImageList, index);
  }

  close(): void {
    this.lightbox.close();
  }

  deleteProfilePhoto(index, template) {
    this.heading = "Remove";
    this.generalvalidationMessage = "Do you want to delete the image?";
    this.selectedIndex = +index;
    this.popupType = "delete";
    this.openModal(template);
  }

  selectedLang: any;
  getLanguage() {
    this.appservice.getlang().subscribe((res) => {
      if (res && res["profilePhotos"]) {
        this.selectedLang = res["profilePhotos"];
      }
    });
  }

  triggerPopupForImageselect() {
    document.getElementById("uploadPhotos").click();
  }

  profileErrorMessage = "";
  profileSuccessMessage = "";
  chooseImagetoUpload(event: any, template, type): void {
    let file;
    if (type === "choose") {
      this.selectedFiles = event.target.files;
      file = this.selectedFiles.item(0);
    }
    if (type === "drag") {
      this.selectedFiles = event;
      file = this.selectedFiles;
    }

    if (file) {
      const checkValidFile = this.getCredential(file);

      if (
        checkValidFile.fileExtenstion === ".JPEG" ||
        checkValidFile.fileExtenstion === ".JPG" ||
        checkValidFile.fileExtenstion === ".jpg" ||
        checkValidFile.fileExtenstion === ".png" ||
        checkValidFile.fileExtenstion === ".jpeg" ||
        checkValidFile.fileExtenstion === ".PNG"
      ) {
        const reader = new FileReader();
        const that = this;

        if (type === "choose") {
          this.imageChangedEvent = event.target.files[0];
          reader.readAsDataURL(event.target.files[0]);
        }
        if (type === "drag") {
          this.imageChangedEvent = event;
          reader.readAsDataURL(event);
        }
        reader.onload = (event: any) => {
          const img = new Image();
          img.src = event.target.result;
          img.onload = function () {
            const w = file.size;
            const width = img.width;
            const height = img.height;
            if (+w <= 20000000 && +width >= 680 && +height >= 720) {
              if (type === "choose") {
                that.awsUploadfiles = that.selectedFiles.item(0);
              }
              if (type === "drag") {
                that.awsUploadfiles = that.selectedFiles;
              }
              that.selectedFiles = null;
              setTimeout(() => {
                that.croppedImage = "";
                that.openModal(template);
              }, 300);
            } else if (+w > 20000000 && +width >= 680 && +height >= 720) {
              that.profileErrorMessage = that.selectedLang.pixelmsgfrLarge;
              setTimeout(() => {
                that.profileErrorMessage = "";
              }, 5000);
            } else {
              that.profileErrorMessage = that.selectedLang.pixelmsg;
              setTimeout(() => {
                that.profileErrorMessage = "";
              }, 5000);
            }
          };
        };
      } else {
        this.profileErrorMessage = this.selectedLang.imageformate;
        setTimeout(() => {
          this.profileErrorMessage = "";
        }, 5000);
      }
    }
  }

  droppedFile: any;
  public dropped(event, template) {
    if (event.files.length > 1) {
      this.heading = "Info";
      this.generalvalidationMessage =
        "Multiple image not allowed to upload, so i get your first image to upload";
      this.popupType = "multiple";
      this.openModal(template);
      this.droppedFile = event.files[0];
    } else {
      const that = this;
      const droppedFile = event.files[0];
      if (droppedFile.fileEntry.isFile) {
        const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
        fileEntry.file((file: File) => {
          that.chooseImagetoUpload(file, this.cropimage, "drag");
        });
      }
    }
  }

  uploadSelectedImage() {
    this.spinner.show();
    this.modalRef.hide();
    this.uploadImage();
  }

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
    this.awsUploadData = event;
  }

  openModal(template) {
    this.modalRef = this.modalService.show(
      template,
      Object.assign(this.config, { class: "popup-center" })
    );
  }

  selectedFiles: FileList;
  imgExtension = [];
  fileName: string;
  fileExtenstion: any;
  imageawskey: any;
  request: any;
  url: any;
  imgUrl: any;

  uploadImage() {
    this.spinner.show();
    this.awsUploadData.file.name = this.awsUploadfiles.name;
    this.selectedFiles = this.awsUploadData.file;
    const file = this.selectedFiles;
    if (file) {
      this.awsUploadFile(file);
    }
  }
  awsImageKeyList: any = [];
  getCredential(file): any {
    this.imgExtension = file.name.slice(file.name.lastIndexOf("."));
    this.fileName = file.name;
    this.fileExtenstion = this.imgExtension;
    const credentials = {
      fileExtenstion: this.imgExtension,
      fileName: file.name,
    };
    return credentials;
  }
  awsUploadFile(file) {
    AWS.config.region = environment.awsRegion;
    console.log(  "identity pool id:",  environment.awsIdentityPoolId.slice(-5));
    AWS.config.credentials = new AWS.CognitoIdentityCredentials({
      IdentityPoolId: environment.awsIdentityPoolId,
    });
    if (file) {
      const that = this;
      const fileDetails = this.getCredential(file);
      const params = this.getParams(file, fileDetails);
      const Obj = this;
      Obj.imageawskey = fileDetails.fileName;
      const bucket = new S3({
        params: {
          Bucket: params.Bucket,
        },
      });
      this.request = bucket
        .upload(params)
        .on("httpUploadProgress", function (evt) {})
        .send(function (err, response) {
          that.spinner.hide();
          const key = response && response.key ? response.key : response.Key;
          const src = environment.cloudFrontURL + key;
          const caption = "Profile photo" + (Obj.savedImageList.length + 1);
          const thumb = environment.cloudFrontURL + key;
          const album = {
            src: src,
            caption: caption,
            thumb: thumb,
            key: key,
            id: Obj.savedImageList.length + 1,
            backenddata: false,
          };
          Obj.savedImageList.push(album);
        });
    }
  }

  profileimageBoolean = false;
  saveImage() {
    this.awsImageKeyList = [];
    for (let index = 0; index < this.savedImageList.length; index++) {
      if (
        this.savedImageList[index].backenddata === false &&
        this.savedImageList[index].key !== null
      ) {
        const savelist = {
          image: this.savedImageList[index].key,
        };
        this.awsImageKeyList.push(savelist);
      }
    }

    if (this.awsImageKeyList.length === 0) {
      this.profileSuccessMessage = "";
      this.profileErrorMessage = "Please choose image";
      setTimeout(() => {
        this.profileErrorMessage = "";
      }, 5000);
      return;
    }

    if (this.awsImageKeyList && this.awsImageKeyList.length > 0) {
      this.profileimageBoolean = true;
      const data = {
        profilePicInput: this.awsImageKeyList,
      };
      this.appservice.saveProfilePic(data).subscribe(
        (res) => {
          if (res && res["status"] && res["status"]["status"] === 200) {
            this.profileSuccessMessage = "Profile Image Updated successfully";
            this.awsImageKeyList = [];
            this.getallsavedimagelist();
            setTimeout(() => {
              this.profileSuccessMessage = "";
            }, 5000);

            if (
              localStorage.getItem("subscriptionflag") !== null &&
              localStorage.getItem("subscriptionflag") === "false"
            ) {
              setTimeout(() => {
                this.router.navigate([
                  localStorage.getItem("testCode").toString().trim(),
                  "technician",
                ]);
              }, 1500);
            }
          }
          this.profileimageBoolean = false;
        },
        (err) => {
          this.appservice.sessionOut(err);
          this.profileimageBoolean = false;
        }
      );
    }
  }

  generalvalidationMessage = "";
  heading = "";
  selectedIndex = 0;
  popupType = "";
  removeSelectedImage(index, template) {
    this.heading = "Remove";
    this.generalvalidationMessage = "Do you want to remove the image?";
    this.selectedIndex = +index;
    this.popupType = "remove";
    this.openModal(template);
  }

  yesButtononPopup() {
    if (this.popupType === "remove") {
      this.awsImageKeyList.splice(this.selectedIndex, 1);
      this.modalRef.hide();
    }
    if (this.popupType === "multiple") {
      const that = this;
      if (this.droppedFile && this.droppedFile.fileEntry.isFile) {
        const fileEntry = this.droppedFile.fileEntry as FileSystemFileEntry;
        fileEntry.file((file: File) => {
          that.chooseImagetoUpload(file, this.cropimage, "drag");
        });
      }
      this.modalRef.hide();
    }
    if (this.popupType === "delete") {
      this.modalRef.hide();
      this.deleteProfileImage();
    }
  }

  noButtononPopup() {
    this.modalRef.hide();
  }

  deleteProfileImage() {
    if (this.savedImageList[this.selectedIndex].backenddata === false) {
      this.savedImageList.splice(this.selectedIndex, 1);
      this.profileErrorMessage = "";
      this.profileSuccessMessage = "Profile image deleted successfully";
      setTimeout(() => {
        this.profileSuccessMessage = "";
      }, 5000);
    } else if (this.savedImageList[this.selectedIndex].backenddata === true) {
      const id = this.savedImageList[this.selectedIndex].id;
      this.appservice.deleteuploadedphotos(id).subscribe(
        (res) => {
          if (res && res["status"] && res["status"]["status"] === 200) {
            this.savedImageList.splice(this.selectedIndex, 1);
            this.profileSuccessMessage = "Profile image deleted successfully";
            setTimeout(() => {
              this.profileSuccessMessage = "";
            }, 5000);
          } else {
            this.getallsavedimagelist();
          }
        },
        (err) => {
          this.appservice.sessionOut(err);
        }
      );
    }
  }

  private getParams(file, fileDetails): any {
    // Math.random() + Date.now() provides sufficient uniqueness for S3 key generation; access security is enforced by AWS IAM/bucket policies, not key secrecy.
    const params = {
      Bucket: environment.s3Bucket,
      Key:
        environment.s3Folder +
        Math.floor(Math.random() * 100000) +
        Date.now().toString() +
        fileDetails.fileExtenstion,
      Body: file,
    };
    return params;
  }
}
